module.exports = __webpack_public_path__ + "img/CUENTO.5e74d93c.png";